export const variety = [
  {
    id: "va15",
    title: "星光音乐会",
    category: "variety",
    genre: "音乐 / 竞演",
    region: "华语",
    year: 2025,
    rating: 8.7,
    duration: "全12期",
    releaseDate: "2025-06-08",
    director: "总导演 晓峰",
    cast: ["林声", "苏曼", "阿澈"],
    tags: ["舞台", "竞演", "live"],
    summary:
      "来自不同城市的音乐人同台竞演，用一场场现场演出，讲述藏在旋律背后的故事。每一次登台，都是一次心跳。",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20music%20competition%20show%20poster%20of%20a%20spotlighted%20concert%20stage%20with%20glowing%20orange%20and%20amber%20lights%20a%20microphone%20silhouette%20and%20crowd%20glow%20energetic%20glamorous%20mood%20cinematic%20vertical%20composition%20high%20detail%20no%20text&width=480&height=720&seq=cover-va15&orientation=portrait",
    hot: 7580,
    updatedAt: "2025-06-08",
  },
  {
    id: "va16",
    title: "极限挑战营",
    category: "variety",
    genre: "真人秀 / 竞技",
    region: "华语",
    year: 2025,
    rating: 8.3,
    duration: "全10期",
    releaseDate: "2025-04-25",
    director: "总导演 大宇",
    cast: ["嘉宾团 六人组"],
    tags: ["户外", "挑战", "团队"],
    summary:
      "六位嘉宾深入山川湖海完成一系列极限任务，在协作与冲突中见证真实的友情。挑战没有剧本，只有全力以赴。",
    cover:
      "https://readdy.ai/api/search-image?query=outdoor%20reality%20challenge%20show%20poster%20of%20contestants%20climbing%20a%20rocky%20mountain%20obstacle%20course%20at%20sunrise%20with%20dramatic%20orange%20sky%20dynamic%20adventurous%20energetic%20mood%20cinematic%20vertical%20composition%20no%20text&width=480&height=720&seq=cover-va16&orientation=portrait",
    hot: 6890,
    updatedAt: "2025-04-25",
  },
  {
    id: "va17",
    title: "美食漫游记",
    category: "variety",
    genre: "美食 / 旅行",
    region: "日韩",
    year: 2024,
    rating: 8.9,
    duration: "全16期",
    releaseDate: "2024-07-14",
    director: "总导演 Yuki",
    cast: ["主持 佐藤", "嘉宾 田中"],
    tags: ["美食", "治愈", "烟火气"],
    summary:
      "两人一车，走遍街头巷尾寻找最地道的市井味道。一碗热汤、一份小吃，藏着最抚凡人心的烟火气。",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20food%20travel%20show%20poster%20of%20a%20steaming%20bowl%20of%20noodles%20on%20a%20warm%20wooden%20table%20in%20a%20lively%20night%20market%20glowing%20lanterns%20appetizing%20warm%20orange%20tones%20inviting%20mood%20vertical%20composition%20high%20detail%20no%20text&width=480&height=720&seq=cover-va17&orientation=portrait",
    hot: 7120,
    updatedAt: "2024-07-14",
  },
  {
    id: "va18",
    title: "喜剧大咖秀",
    category: "variety",
    genre: "喜剧 / 语言",
    region: "华语",
    year: 2025,
    rating: 8.5,
    duration: "全14期",
    releaseDate: "2025-09-06",
    director: "总导演 老周",
    cast: ["喜剧团 八人组"],
    tags: ["脱口秀", "搞笑", "语言"],
    summary:
      "八位喜剧人轮番登台，用段子和表演解构生活里的鸡毛蒜皮。笑点密集，包袱不断，专治各种不开心。",
    cover:
      "https://readdy.ai/api/search-image?query=stand%20up%20comedy%20show%20poster%20of%20a%20lone%20microphone%20stand%20under%20a%20single%20warm%20orange%20spotlight%20on%20a%20dark%20stage%20with%20velvet%20curtains%20playful%20confident%20mood%20minimal%20dramatic%20cinematic%20vertical%20composition%20no%20text&width=480&height=720&seq=cover-va18&orientation=portrait",
    hot: 7410,
    updatedAt: "2025-09-06",
    badge: "爆笑",
  },
  {
    id: "va19",
    title: "亲子奇遇记",
    category: "variety",
    genre: "亲子 / 户外",
    region: "华语",
    year: 2024,
    rating: 8.2,
    duration: "全12期",
    releaseDate: "2024-03-30",
    director: "总导演 楠楠",
    cast: ["家庭组 四组"],
    tags: ["亲子", "冒险", "温馨"],
    summary:
      "四组家庭共同踏上一段寻宝旅程，孩子与父母在合作中重新认识彼此。原来长大和陪伴，从来都值得记录。",
    cover:
      "https://readdy.ai/api/search-image?query=family%20friendly%20adventure%20show%20poster%20of%20a%20parent%20and%20child%20holding%20hands%20at%20a%20bright%20amusement%20park%20with%20colorful%20balloons%20happy%20joyful%20warm%20sunny%20mood%20playful%20illustration%20vertical%20composition%20high%20detail%20no%20text&width=480&height=720&seq=cover-va19&orientation=portrait",
    hot: 5980,
    updatedAt: "2024-03-30",
  },
];